export default "__VITE_ASSET__Dglu1DnQ__"